"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = void 0;
const utils_1 = require("@ganache/utils");
class Address extends utils_1.Data {
    constructor(value) {
        super(value, Address.ByteLength);
    }
    static from(value) {
        return new Address(value);
    }
    static toBuffer(value) {
        return Address.from(value).toBuffer();
    }
    static toString(value) {
        return Address.from(value).toString();
    }
}
exports.Address = Address;
Address.ByteLength = 20;
//# sourceMappingURL=index.js.map